import React, { useState, useEffect, useContext } from 'react';
import { Modal, ModalHeader, ModalBody, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import { AppContext } from '../../application/provider';
import Loader from '../Loader/Loader';

const EMPTY_FORM = {
    rh_administracion_id: null,
    area: '',
    apellidos_nombre: '',
    cargo: '',
    empresa_id: '',
    rxh_factura: 'E001-',
    pago_mes: 0,
    bono_gestion: 0,
    descuento: 0,
    detraccion: 0,
    importe_neto: 0,
    dni: '',
    n_cuenta: '',
    cci: '',
    banco_pago: '',
    n_cuenta_detraccion: '',
    banco_detraccion: '',
};

const PLANTILLAS = [
    {
        label: 'RAMIREZ TAIPE ALEXANDER MAXIMO',
        data: {
            area: 'ADMINISTRATIVO', apellidos_nombre: 'RAMIREZ TAIPE ALEXANDER MAXIMO',
            cargo: 'GESTOR DE PROYECTOS', empresa_id: 1, rxh_factura: 'E001-', pago_mes: 1000, bono_gestion: 0, descuento: 0,
            importe_neto: 1000, detraccion: 0, dni: '45121137', n_cuenta: '107013211001733001',
            cci: '80801321100173300175', banco_pago: 'CAJA HUANCAYO', n_cuenta_detraccion: '', banco_detraccion: ''
        }
    },
    {
        label: 'INNOVA NETWORKING SAC',
        data: {
            area: 'EMPRESA', apellidos_nombre: 'INNOVA NETWORKING SAC',
            cargo: '', empresa_id: 1, rxh_factura: 'E001-', pago_mes: 1500, bono_gestion: 0, descuento: 0,
            importe_neto: 1320, detraccion: 180, dni: '44894675', n_cuenta: '107002211012998307',
            cci: '80800221101299830703', banco_pago: 'CAJA HUANCAYO', n_cuenta_detraccion: '00386041881', banco_detraccion: 'NACION'
        }
    },
    {
        label: 'HUATUCO RIVERA RODOLFO MARCELO (MEC INGENIEROS)',
        data: {
            area: 'ADMINISTRATIVO', apellidos_nombre: 'HUATUCO RIVERA RODOLFO MARCELO',
            cargo: 'ASESOR CONTABLE', empresa_id: 1, rxh_factura: 'E001-', pago_mes: 1000, bono_gestion: 0, descuento: 0,
            importe_neto: 1000, detraccion: 0, dni: '28718998', n_cuenta: '8983135051561',
            cci: '00389801313505156148', banco_pago: 'INTERBANK', n_cuenta_detraccion: '', banco_detraccion: ''
        }
    },
    {
        label: 'HUATUCO RIVERA RODOLFO MARCELO (CAPITALES)',
        data: {
            area: 'ADMINISTRATIVO', apellidos_nombre: 'HUATUCO RIVERA RODOLFO MARCELO',
            cargo: 'ASESOR CONTABLE', empresa_id: 2, rxh_factura: 'E001-', pago_mes: 200, bono_gestion: 0, descuento: 0,
            importe_neto: 200, detraccion: 0, dni: '28718998', n_cuenta: '8983135051561',
            cci: '00389801313505156148', banco_pago: 'INTERBANK', n_cuenta_detraccion: '', banco_detraccion: ''
        }
    }
];

const calcImporteNeto = (f) => {
    const pago = parseFloat(f.pago_mes) || 0;
    const bono = parseFloat(f.bono_gestion) || 0;
    const desc = parseFloat(f.descuento) || 0;
    const detr = parseFloat(f.detraccion) || 0;
    return parseFloat(((pago - desc) + bono - detr).toFixed(2));
};

const ModalAgregarRhAdministracion = ({ isOpen, onClose, onSave, editItem }) => {
    const [state] = useContext(AppContext);
    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState(EMPTY_FORM);

    const empresaOptions = state?.catalogos?.tipos?.filter(t => Number(t.categoria_id) === 37) || [];

    useEffect(() => {
        if (isOpen) {
            if (editItem) {
                setFormData({
                    ...EMPTY_FORM,
                    ...editItem,
                    pago_mes: editItem.pago_mes ?? 0,
                    bono_gestion: editItem.bono_gestion ?? 0,
                    descuento: editItem.descuento ?? 0,
                    detraccion: editItem.detraccion ?? 0,
                });
            } else {
                setFormData(EMPTY_FORM);
            }
        }
    }, [isOpen, editItem]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => {
            const updated = { ...prev, [name]: value };
            updated.importe_neto = calcImporteNeto(updated);
            return updated;
        });
    };

    const handleSelectPlantilla = (e) => {
        const val = e.target.value;
        if (val === '') {
            setFormData(EMPTY_FORM);
        } else {
            const index = parseInt(val, 10);
            if (PLANTILLAS[index]) {
                const newData = { ...EMPTY_FORM, ...PLANTILLAS[index].data };
                newData.importe_neto = calcImporteNeto(newData);
                setFormData(newData);
            }
        }
    };

    const handleSave = async () => {
        if (!formData.apellidos_nombre.trim()) {
            alert('El campo Apellidos y Nombre es obligatorio.');
            return;
        }
        setIsLoading(true);
        try {
            await onSave({
                ...formData,
                pago_mes: parseFloat(formData.pago_mes) || 0,
                bono_gestion: parseFloat(formData.bono_gestion) || 0,
                descuento: parseFloat(formData.descuento) || 0,
                detraccion: parseFloat(formData.detraccion) || 0,
                importe_neto: calcImporteNeto(formData),
            });
        } catch (err) {
            alert('Error al guardar: ' + (err.response?.data?.error || err.message));
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Modal isOpen={isOpen} className="custom-modal" backdrop="static" size="md" centered>
            <ModalHeader className="modal-header">
                <div className="titulo">
                    <h1>{editItem ? 'EDITAR REGISTRO' : 'NUEVO REGISTRO'} - RECIBO POR HONORARIOS</h1>
                    <button className="close-btn" onClick={onClose}>X</button>
                </div>
            </ModalHeader>

            <div className="modal-body-footer">
                <ModalBody className="modal-body p-4">
                    {isLoading && <Loader />}

                    <Form className="px-4 mt-2">

                        <FormGroup className="mb-3">
                            <Label className="fw-bold text-primary">Autocompletar con Plantilla:</Label>
                            <Input
                                type="select"
                                onChange={handleSelectPlantilla}
                                className="form-control bg-light"
                                disabled={!!editItem}
                            >
                                <option value="">Ingreso Manual (Vacío)</option>
                                {PLANTILLAS.map((p, i) => (
                                    <option key={i} value={i}>{p.label}</option>
                                ))}
                            </Input>
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <Label for="area">Área</Label>
                            <Input
                                type="text"
                                name="area"
                                id="area"
                                value={formData.area}
                                onChange={e => handleChange({ target: { name: 'area', value: e.target.value.toUpperCase() } })}
                                className="form-control"
                                placeholder="Ingresa el área"
                            />
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <Label for="apellidos_nombre">Apellidos y Nombre <span className="text-danger">*</span></Label>
                            <Input
                                type="text"
                                name="apellidos_nombre"
                                id="apellidos_nombre"
                                value={formData.apellidos_nombre}
                                onChange={e => handleChange({ target: { name: 'apellidos_nombre', value: e.target.value.toUpperCase() } })}
                                className="form-control"
                                placeholder="Ingresa los apellidos y nombre completo"
                            />
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <Label for="cargo">Cargo</Label>
                            <Input
                                type="text"
                                name="cargo"
                                id="cargo"
                                value={formData.cargo}
                                onChange={e => handleChange({ target: { name: 'cargo', value: e.target.value.toUpperCase() } })}
                                className="form-control"
                                placeholder="Ingresa el cargo o función que desempeña"
                            />
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <Label for="empresa_id">Empresa</Label>
                            <Input
                                type="select"
                                name="empresa_id"
                                id="empresa_id"
                                value={formData.empresa_id}
                                onChange={handleChange}
                                className="form-control"
                            >
                                <option value="">Seleccionar empresa...</option>
                                {empresaOptions.map(opt => (
                                    <option key={opt.tipo_id} value={opt.tipo_id}>
                                        {(opt.descripcion || opt.nombre || '').toUpperCase()}
                                    </option>
                                ))}
                            </Input>
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <Label for="rxh_factura">RxH / Factura</Label>
                            <Input
                                type="text"
                                name="rxh_factura"
                                id="rxh_factura"
                                value={formData.rxh_factura}
                                onChange={handleChange}
                                className="form-control"
                                placeholder="Ingresa el número de recibo o factura"
                            />
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <Label for="pago_mes">Total a Pagar Mes (S/)</Label>
                            <Input
                                type="number"
                                name="pago_mes"
                                id="pago_mes"
                                step="0.01"
                                min="0"
                                value={formData.pago_mes}
                                onChange={handleChange}
                                className="form-control"
                                placeholder="Ingresa el monto total a pagar este mes"
                            />
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <Label for="bono_gestion">Bono por Gestión (S/)</Label>
                            <Input
                                type="number"
                                name="bono_gestion"
                                id="bono_gestion"
                                step="0.01"
                                min="0"
                                value={formData.bono_gestion}
                                onChange={handleChange}
                                className="form-control"
                                placeholder="Ingresa el bono por gestión si aplica"
                            />
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <Label for="descuento">Descuento Tardanza (S/)</Label>
                            <Input
                                type="number"
                                name="descuento"
                                id="descuento"
                                step="0.01"
                                min="0"
                                value={formData.descuento}
                                onChange={handleChange}
                                className="form-control"
                                placeholder="Ingresa el descuento por tardanza si aplica"
                            />
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <Label for="detraccion">Detracción (S/)</Label>
                            <Input
                                type="number"
                                name="detraccion"
                                id="detraccion"
                                step="0.01"
                                min="0"
                                value={formData.detraccion}
                                onChange={handleChange}
                                className="form-control"
                                placeholder="Ingresa el monto de detracción si aplica"
                            />
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <Label>Importe Neto a Pagar (S/)</Label>
                            <Input
                                type="text"
                                value={new Intl.NumberFormat('es-PE', { style: 'currency', currency: 'PEN' }).format(calcImporteNeto(formData))}
                                disabled
                                className="form-control fw-bold"
                            />
                        </FormGroup>

                        <hr />

                        <FormGroup className="mb-3">
                            <Label for="dni">N° DNI</Label>
                            <Input
                                type="text"
                                name="dni"
                                id="dni"
                                maxLength={8}
                                value={formData.dni}
                                onChange={handleChange}
                                className="form-control"
                                placeholder="Ingresa el número de DNI"
                            />
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <Label for="n_cuenta">N° Cuenta</Label>
                            <Input
                                type="text"
                                name="n_cuenta"
                                id="n_cuenta"
                                value={formData.n_cuenta}
                                onChange={handleChange}
                                className="form-control"
                                placeholder="Ingresa el número de cuenta bancaria"
                            />
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <Label for="cci">CCI</Label>
                            <Input
                                type="text"
                                name="cci"
                                id="cci"
                                value={formData.cci}
                                onChange={handleChange}
                                className="form-control"
                                placeholder="Ingresa el código de cuenta interbancaria"
                            />
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <Label for="banco_pago">Banco</Label>
                            <Input
                                type="text"
                                name="banco_pago"
                                id="banco_pago"
                                value={formData.banco_pago}
                                onChange={e => handleChange({ target: { name: 'banco_pago', value: e.target.value.toUpperCase() } })}
                                className="form-control"
                                placeholder="Ingresa el nombre del banco"
                            />
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <Label for="n_cuenta_detraccion">N° Cuenta de Detracción</Label>
                            <Input
                                type="text"
                                name="n_cuenta_detraccion"
                                id="n_cuenta_detraccion"
                                value={formData.n_cuenta_detraccion}
                                onChange={handleChange}
                                className="form-control"
                                placeholder="Ingresa el número de cuenta de detracción"
                            />
                        </FormGroup>

                        <FormGroup className="mb-3">
                            <Label for="banco_detraccion">Banco Detracción</Label>
                            <Input
                                type="text"
                                name="banco_detraccion"
                                id="banco_detraccion"
                                value={formData.banco_detraccion}
                                onChange={e => handleChange({ target: { name: 'banco_detraccion', value: e.target.value.toUpperCase() } })}
                                className="form-control"
                                placeholder="Ingresa el banco de detracción si aplica"
                            />
                        </FormGroup>

                        <div className="flex justify-end mt-4 pb-3">
                            <Button
                                className="btn-primary px-5 py-2"
                                onClick={handleSave}
                                style={{ borderRadius: '8px' }}
                                disabled={isLoading}
                            >
                                GUARDAR
                            </Button>
                        </div>

                    </Form>
                </ModalBody>
            </div>
        </Modal>
    );
};

export default ModalAgregarRhAdministracion;
